import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SafeModule } from 'src/app/@core/pipes/pipe-modules/safe.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SliderImagesMaterialComponent } from './slider.component';
import { MatButtonModule } from '@angular/material/button';




@NgModule({
  declarations: [
    SliderImagesMaterialComponent
  ],
  imports: [
    CommonModule,
    SafeModule.forRoot(),
    FlexLayoutModule,
    MatButtonModule,
    FormsModule
  ],
  exports: [SliderImagesMaterialComponent]
})
export class SliderImagesMaterialModule {}